import React from 'react';
import UserRolesManagementContent from '../components/UserRolesManagementContent';

/** Rôles utilisateurs — contenu intégré au shell panel v1. */
const PanelUserRolesEmbedV1: React.FC = () => (
  <div className="rounded-xl border border-[#223046]/90 bg-[#0e1522]/75 p-4 backdrop-blur-sm">
    <UserRolesManagementContent />
  </div>
);

export default PanelUserRolesEmbedV1;
